export enum IncutType {
  Expander = 'expander',
  Text = 'text',
}
